import { useCallback, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { rangeFromSearch, rangeToSearch, todayEastern, type DateRange } from './visitorsRange'

/** The Visitors date range lives in the URL so every page and drill link shares it. */
export function useVisitorsRange() {
  const [sp, setSp] = useSearchParams()
  const spKey = sp.toString()
  const range = useMemo(() => rangeFromSearch(new URLSearchParams(spKey), todayEastern()), [spKey])
  const search = useMemo(() => new URLSearchParams(rangeToSearch(range)).toString(), [range])
  const setRange = useCallback(
    (r: DateRange) => {
      const next = new URLSearchParams(spKey)
      for (const k of ['range', 'from', 'to']) next.delete(k)
      for (const [k, v] of Object.entries(rangeToSearch(r))) next.set(k, v)
      setSp(next)
    },
    [spKey, setSp],
  )
  return { range, search, setRange }
}
